/**
 * Scribe Studio — Instagram feed renderer
 * Fetches JSON from the Cloudflare Worker proxy and renders a responsive grid.
 * Falls back to a "view on Instagram" link if the fetch fails for any reason.
 */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", init);
  // In case DOMContentLoaded already fired (defer should prevent this, but be safe)
  if (document.readyState === "interactive" || document.readyState === "complete") {
    init();
  }

  function init() {
    var grid = document.getElementById("ig-feed-grid");
    if (!grid) return;

    var workerUrl = grid.getAttribute("data-worker-url");
    var limit = parseInt(grid.getAttribute("data-post-limit"), 10) || 123;

    if (!workerUrl) {
      renderError(grid, "Feed not configured yet — add your Worker URL in the theme editor.");
      return;
    }

    fetch(workerUrl.replace(/\/$/, "") === workerUrl ? workerUrl : workerUrl)
      .then(function (res) {
        if (!res.ok) throw new Error("Feed request failed: " + res.status);
        return res.json();
      })
      .then(function (data) {
        var posts = (data.posts || []).slice(0, limit);
        if (!posts.length) {
          renderError(grid, "No posts found.");
          return;
        }
        renderGrid(grid, posts);
      })
      .catch(function (err) {
        console.error("[Scribe Studio IG feed]", err);
        renderError(grid, "Couldn't load the live feed right now.");
      });
  }

  function renderGrid(grid, posts) {
    grid.innerHTML = "";
    grid.classList.add("ig-feed-grid--loaded");

    posts.forEach(function (post) {
      var item =
        buildLinkItem(post); // Editorial grid: all posts render as static cover tiles linking to Instagram
      grid.appendChild(item);
    });
  }

  // Photos and carousels: whole tile links out to the Instagram post, as before.
  function buildLinkItem(post) {
    var item = document.createElement("a");
    item.className = "ig-feed-item";
    item.href = post.permalink;
    item.target = "_blank";
    item.rel = "noopener";
    item.setAttribute("aria-label", truncateCaption(post.caption));

    var imgWrap = document.createElement("div");
    imgWrap.className = "ig-feed-item__media";

    var img = document.createElement("img");
    img.src = post.coverUrl || post.mediaUrl;
    img.alt = truncateCaption(post.caption) || "Scribe Studio Instagram post";
    img.loading = "lazy";
    imgWrap.appendChild(img);

    if (post.type === "CAROUSEL_ALBUM") {
      var badge2 = document.createElement("span");
      badge2.className = "ig-feed-item__badge ig-feed-item__badge--carousel";
      badge2.innerHTML = "&#8862;";
      imgWrap.appendChild(badge2);
    }

    var overlay = document.createElement("div");
    overlay.className = "ig-feed-item__overlay";
    var overlayText = document.createElement("span");
    overlayText.textContent = truncateCaption(post.caption);
    overlay.appendChild(overlayText);
    imgWrap.appendChild(overlay);
    var enquire = document.createElement("span"); enquire.className = "ig-feed-item__enquire"; enquire.setAttribute("role", "link"); enquire.tabIndex = 0; enquire.textContent = "Enquire Now"; var openDm = function (e) { e.preventDefault(); e.stopPropagation(); window.open("https://ig.me/m/scribestudio.au", "_blank", "noopener"); }; enquire.addEventListener("click", openDm); enquire.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") openDm(e); }); imgWrap.appendChild(enquire); // Enquire Now pill: opens an Instagram DM

    item.appendChild(imgWrap);
    return item;
  }

  // Videos: play inline right on the page via a native <video> element (using the direct
  // mp4 URL the Worker already returns), instead of sending people off to Instagram.
  // A small corner link is kept for anyone who wants to open the post itself.
  function buildVideoItem(post) {
    var item = document.createElement("div");
    item.className = "ig-feed-item ig-feed-item--video";

    var mediaWrap = document.createElement("div");
    mediaWrap.className = "ig-feed-item__media";

    var video = document.createElement("video");
    video.className = "ig-feed-item__video";
    video.controls = true;
    video.preload = "metadata";
    video.playsInline = true;
    video.setAttribute("playsinline", ""); // older iOS Safari needs the attribute form too
    if (post.coverUrl || post.mediaUrl) {
      video.poster = post.coverUrl || post.mediaUrl;
    }

    var source = document.createElement("source");
    source.src = post.videoUrl;
    source.type = "video/mp4";
    video.appendChild(source);
    mediaWrap.appendChild(video);

    var linkOut = document.createElement("a");
    linkOut.className = "ig-feed-item__link-out";
    linkOut.href = post.permalink;
    linkOut.target = "_blank";
    linkOut.rel = "noopener";
    linkOut.setAttribute("aria-label", "View this post on Instagram");
    linkOut.innerHTML = "&#8599;";
    mediaWrap.appendChild(linkOut);

    item.appendChild(mediaWrap);
    return item;
  }

  function renderError(grid, message) {
    grid.innerHTML =
      '<p class="ig-feed-grid__error">' +
      message +
      ' <a href="https://www.instagram.com/scribestudio.au/" target="_blank" rel="noopener">View on Instagram instead</a>.</p>';
  }

  function truncateCaption(caption) {
    if (!caption) return "";
    var firstLine = caption.split("\n")[0];
    return firstLine.length > 90 ? firstLine.slice(0, 90) + "…" : firstLine;
  }
})();
